export default function normalizeUrl(url: string | null | undefined, addDotCom: boolean) {
    url = (url || '').trim();

    if (addDotCom && url && url.indexOf('.') == -1) {
        url = url + '.com';
    }

    if (url && url.indexOf('://') == -1) {
        url = 'https://' + url;
    }

    return url;
}
